<template>
  <div class="app-container">
    <BjRouteTabs :route-list="BUSINESS_REPORT_SALE_ROUTE_LIST" />
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :before-reset-search="beforeResetSearch"
      :is-pagination="false"
      is-list
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessReportSaleShop.orderTime')">
            <BjDateTimerangePicker v-model="queryParamsTime" :placeholder="$t('BusinessReportSaleShop.orderTime')" />
          </el-form-item>
        </el-col>
        <BjSelectChannelStore
          :span="colSpan"
          :query-params="queryParams"
          :query-props="['channel', 'storeIds']"
          multiple
        />
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessReportSaleShop.storeType')" prop="storeType">
            <BjSelectLov v-model="queryParams.storeType" :placeholder="$t('BusinessReportSaleShop.storeType')" :option-list="SHOP_TYPE_LIST" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessReportSaleShop.organization')" prop="organization">
            <BjInput
              v-model="queryParams.organization"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('BusinessReportSaleShop.organization')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            :sortable="
              [
                'storeCode',
                'orderCount',
                'orderAmount',
                'reverseOrderCount',
                'reverseOrderAmount',
              ].includes(col.prop)
            "
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="['orderAmount', 'reverseOrderAmount'].includes(col.prop)">
                {{ $number2money(scope.row[col.prop]) }}
              </template>
              <template v-else-if="col.prop === 'storeTypeCode'">
                {{ $t(SHOP_TYPE_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { reportApi } from '@/api';
import { BUSINESS_REPORT_SALE_ROUTE_LIST, SHOP_TYPE_LIST } from '@/utils/constants';
// 导入默认时间（两周前-今日），报表多页面通用
import { defaultDate, disabledDate } from '../commonData';

export default {
  name: 'BusinessReportSaleShopIndex',
  components: {},
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 4,
      selection: false,
      BUSINESS_REPORT_SALE_ROUTE_LIST,
      SHOP_TYPE_LIST,
      /** */
      queryApi: reportApi.getChannelorderReport,
      // 查询参数
      queryParamsTime: defaultDate(),
      // 已核对字段
      queryParams: {
        startDate: null,
        endDate: null,
        channel: null,
        storeIds: [],
        storeType: null,
        organization: null,
      },
      pickerOptions: {
        // 限制时间选择一年内
        disabledDate(time) {
          return disabledDate(time);
        },
      },
      labelsVersion: 11,
      labelList: [
        {
          label: this.$t('SalesChannelText'),
          prop: 'channelName',
          isCheck: true,
          disabled: false,
          width: 190
        },
        {
          label: this.$t('BusinessReportSaleShop.storeName'),
          prop: 'storeName',
          isCheck: true,
          disabled: false,
          width: 200
        },
        {
          label: this.$t('BusinessReportSaleShop.storeCode'),
          prop: 'storeCode',
          isCheck: true,
          disabled: false,
          width: 180
        },
        {
          label: this.$t('BusinessReportSaleShop.organization'),
          prop: 'organizationName',
          isCheck: true,
          disabled: false,
          width: 180
        },
        {
          label: this.$t('BusinessReportSaleShop.storeType'),
          prop: 'storeTypeCode',
          isCheck: true,
          disabled: false,
          width: 180
        },
        {
          label: this.$t('BusinessReportSaleShop.orderCount'),
          prop: 'orderCount',
          isCheck: true,
          disabled: false,
          width: 180
        },
        {
          label: this.$t('BusinessReportSaleShop.orderAmount'),
          prop: 'orderAmount',
          isCheck: true,
          disabled: false,
          width: 180
        },
        {
          label: this.$t('BusinessReportSaleShop.reverseOrderCount'),
          prop: 'reverseOrderCount',
          isCheck: true,
          disabled: false,
          width: 180
        },
        {
          label: this.$t('BusinessReportSaleShop.reverseOrderAmount'),
          prop: 'reverseOrderAmount',
          isCheck: true,
          disabled: false,
          width: 180
        },
        // { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 129},
      ],
    };
  },
  computed: {},
  watch: {
    queryParamsTime: {
      handler(v) {
        this.queryParams.startDate = (v || [])[0];
        this.queryParams.endDate = (v || [])[1];
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime = defaultDate();
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>
<style scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
